module.exports = __webpack_public_path__ + "img/close.4339552.svg";